import React, { useState } from 'react';
import MarkdownEditor from '@uiw/react-markdown-editor';
import { FiCopy, FiCheck } from 'react-icons/fi';
import '@uiw/react-markdown-editor/markdown-editor.css';
import '@uiw/react-markdown-preview/markdown.css';
import 'github-markdown-css/github-markdown.css';
import "./markdown-editor.css";

export default function RawPreview({ text = '' }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      // Fallback for older browsers or HTTP (non-secure) contexts
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }
  };

  const displayText = text || 'No content to display';

  return (
    <div className="relative h-full flex flex-col bg-gray-50 rounded-lg border border-gray-200 overflow-hidden">
      {/* Copy Button - Fixed position, high z-index, always visible */}
      <div className="absolute top-4 right-4 z-10 pointer-events-auto">
        <button
          onClick={handleCopy}
          className={`
            flex items-center gap-2 px-4 py-2.5 rounded-lg
            bg-white border border-gray-300 shadow-lg
            hover:bg-gray-50 hover:border-gray-400 hover:shadow-xl
            focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2
            transition-all duration-200 font-medium text-sm
          `}
          aria-label={copied ? 'Copied!' : 'Copy to clipboard'}
          title={copied ? 'Copied!' : 'Copy to clipboard'}
        >
          {copied ? (
            <>
              <FiCheck className="h-5 w-5 text-emerald-600" />
              <span className="text-emerald-600">Copied!</span>
            </>
          ) : (
            <>
              <FiCopy className="h-5 w-5 text-gray-600" />
              <span className="text-gray-700">Copy</span>
            </>
          )}
        </button>

        {/* Optional floating tooltip */}
        {copied && (
          <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 bg-gray-800 text-white text-xs px-3 py-1.5 rounded shadow-lg whitespace-nowrap">
            Copied to clipboard!
          </div>
        )}
      </div>

      {/* Markdown Editor in Read-Only Raw Mode */}
      <div className="h-full w-full overflow-hidden">
        <MarkdownEditor
          value={displayText}
          preview="edit"           // Shows only the editor (raw text)
          enablePreview={false}    // Disables preview pane
          toolbars={false}         // Hides toolbar completely
          visible={true}
          height="72vh"
          options={{
            readOnly: true,        // Important: disables editing
            cursorBlinkRate: -1,   // Hides blinking cursor
          }}
          style={{
            backgroundColor: 'transparent',
            fontFamily: 'inherit',
          }}
          className="raw-markdown-view"
        />
      </div>
    </div>
  );
}